import { Button, Modal, notification } from 'antd'
import React, { useState } from 'react'

import { httpClient } from '../../../../../util/http-client'
import { ratingCompliancesRulesMessages } from '../messages'
import { RatingComplianceRule } from '../models'

interface DeleteRatingComplianceRuleProps {
  domain: string
  groupId: number
  rule: RatingComplianceRule
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteRatingComplianceRuleModal = ({
  domain,
  groupId,
  rule,
  isVisible,
  onClose,
  onSuccess,
}: DeleteRatingComplianceRuleProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (groupId: number, ruleId: number) => {
    setIsDeleting(true)

    try {
      await httpClient(`/compliances/ratings/groups/${groupId}/rules/${ruleId}`, {
        method: 'DELETE',
        domain,
      })
      onSuccess()

      notification.success({
        message: ratingCompliancesRulesMessages.common.success,
        description: ratingCompliancesRulesMessages.delete.success,
      })
    } catch (error) {
      notification.error({
        message: ratingCompliancesRulesMessages.common.error,
        description: error.error_message || ratingCompliancesRulesMessages.delete.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete Rating Compliance Rule"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(groupId, rule.id)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
          >
            Delete
          </Button>
        </div>,
      ]}
    >
      {buildDeleteMessage(rule)}
    </Modal>
  )
}

const buildDeleteMessage = (rule: RatingComplianceRule) =>
  `Are you sure that you want to delete this rating compliance rule?\n
  - Type: ${rule?.ratingType}\n
  - Rating: ${rule?.rating}\n
  - Max Limit: ${rule?.maxLimit}\n
  It cannot be reverted`
